import { ScannerModule } from 'game/state/BotState';
import { Processor } from '../Processor';

export const scannerProcessor: Processor<ScannerModule> = () => {
  return { status: 'null' };
};
